module.exports = __webpack_public_path__ + "img/電気回路_2_1.f6ef4759.png";